import { css } from 'styled-components';
import { mqLargeMax } from './tools/media-queries';

const SiteDocument = css`
  html {
    background: var(--fill-primary);
    font-size: var(--font-size-400);
    min-height: 100%;
  }

  body {
    color: var(--text-primary);
    font-family: var(--ff-sans);
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    line-height: 1.4;
    margin: 0;
    min-height: 100%;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }

  .has-menu,
  .has-annotation,
  .has-loader {
    overflow: hidden;
  }

  main {
    transition: transform 0.25s cubic-bezier(0.75, 0, 0.25, 1);
    position: relative;
    z-index: 1;
  }

  .has-annotation main {
    transform: translate3d(-600px, 0, 0);

    @media ${mqLargeMax} {
      transform: translate3d(-95%, 0, 0);
    }
  }
`;

export { SiteDocument };
